import { render, staticRenderFns } from "./documentationEditor.vue?vue&type=template&id=31bea308&"
import script from "./documentationEditor.vue?vue&type=script&lang=js&"
export * from "./documentationEditor.vue?vue&type=script&lang=js&"
import style0 from "./documentationEditor.vue?vue&type=style&index=0&id=31bea308&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports